import { Box, Slider, Stack, IconButton } from '@mui/material';
import { styled } from "@mui/system";
import { FullScreen } from 'react-full-screen'

// マップのスライダー表示用ボックス
export const StackMapSlider = styled(Stack)(() => (
    {
        alignItems: 'center',
        position: 'absolute',
        width: '70%',
        minWidth: '350px',
        left: 10,
        bottom: 10,
        backgroundColor: 'rgb(6, 16, 39, 0.67)',
        zIndex: 1000,
        borderRadius: '4px',
        padding: '0 0.5rem'
    }));
export const BoxMapSlider = styled(Box)(() => (
    {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'start',
        width: '100%',
        minWidth: '350px',
    }));

export const MapSlider = styled(Slider)(({ theme }) => ({
    color: theme.palette.mode === 'dark' ? '#0a84ff' : '#007bff',
    padding: '15px 0',
    position: 'absolute',
    left: 10,
    bottom: 10,
    zIndex: 1000,
    '& .MuiSlider-track': {
        height: '10px',
        backgroundColor: 'rgba(43, 85, 150, 1)',
        border: '2px solid rgba(0, 0, 0, 0.3)',
    },
    '& .MuiSlider-thumb': {
        height: '20px',
        width: '20px',
        backgroundColor: '#fff',
        boxShadow: '0 0 2px 0px rgba(0, 0, 0, 0.1)',
    },
    '& .MuiSlider-rail': {
        height: '10px',
        opacity: 1,
        boxShadow: 'inset 0px 0px 4px -2px #000',
        backgroundColor: 'rgba(8, 16, 37, 1)',
    },
    '& .MuiSlider-mark[data-index="7"]': {
        backgroundColor: 'rgb(192, 37, 24)',
        height: '10px',
        width: '10px',
        transform: 'translate(-5px, -50%)',
        borderRadius: '50%',
    },
    '& .MuiSlider-markLabel': {
        fontSize: '0.8rem',
        color: '#fff',
        fontWeight: 'bold',
    },
}));
export const StyleFullScreen = styled(FullScreen)`
    width: 100%;
    height: 100%;
    &.fullscreen-enabled>div{
        height: 100%;
    }
`
export const FullScreenIconButton = styled(IconButton)(() => (
    {
        position: 'absolute',
        width: '29px',
        height: '29px',
        top: '70px',
        right: '10px',
        zIndex: 500,
        border: '1px solid rgba(0, 0, 0, 0.3)',
        borderRadius: '5px',
        backgroundColor: 'white',
        '&:hover': {
            backgroundColor: 'rgb(243, 243, 243)'
        }
    }));
export const LayersIconButton = styled(IconButton)(() => (
    {
        position: 'absolute',
        width: '29px',
        height: '29px',
        top: '10px',
        right: '10px',
        zIndex: 500,
        border: '1px solid rgba(0, 0, 0, 0.3)',
        borderRadius: '5px',
        backgroundColor: 'white',
        '&:hover': {
            backgroundColor: 'rgb(243, 243, 243)'
        }
    }));

export const LegendIconButton = styled(IconButton)(({ top }) => ({
    position: 'absolute',
    width: '29px',
    height: '29px',
    top: top ?? '40px',   // ← props.top があればそれを使う
    right: '10px',
    zIndex: 500,
    border: '1px solid rgba(0, 0, 0, 0.3)',
    borderRadius: '5px',
    backgroundColor: 'white',
    '&:hover': {
        backgroundColor: 'rgb(243, 243, 243)'
    }
}));
export const MapWrapper = styled(Box)(() => (
    {
        position: 'relative',
        width: '100%',
        height: '100%',
    }));

